import { render, staticRenderFns } from "./SetupReviewMeeting.vue?vue&type=template&id=40359a90&"
import script from "./SetupReviewMeeting.vue?vue&type=script&lang=ts&"
export * from "./SetupReviewMeeting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports